import { Message, toaster } from "rsuite";

export const toastSuccess = (message = '') => {
    if (!message) {
        return;
    }

    toaster.push(
        <Message showIcon type="success">
            {message}
        </Message>,
    );
}